import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@ah/ui/tokens.css';
import { App } from './app/App';
import { registerServiceWorker } from './pwa/register';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root is missing in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
